import request from '@/utils/request'

// 获取所有的Role
export function getAll() {
  return request({
    url: 'admin-auth/api/roles/all',
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'admin-auth/api/roles',
    method: 'post',
    data
  })
}

export function get(id) {
  return request({
    url: 'admin-auth/api/roles/' + id,
    method: 'get'
  })
}

export function getLevel() {
  return request({
    url: 'admin-auth/api/roles/level',
    method: 'get'
  })
}

export function del(ids) {
  return request({
    url: 'admin-auth/api/roles',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'admin-auth/api/roles',
    method: 'put',
    data
  })
}

export function editMenu(data) {
  return request({
    url: 'admin-auth/api/roles/menu',
    method: 'put',
    data
  })
}

export default { add, edit, del, get, editMenu, getLevel }
